import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegExp } from 'src/app/core/config/regex';
import { Context } from 'src/app/shared/models/context';
import { Bank, EmployeeInsurance, Family, Image, Insurance, InsurancePlan, Message, Nominee } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { CompanyService } from 'src/app/shared/services/company.service';
import { DomainService } from 'src/app/shared/services/domain.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { SettingsService } from 'src/app/shared/services/settings.service';
@Component({
  selector: 'app-employee-insurance-crud',
  templateUrl: './employee-insurance-crud.component.html',
  styleUrls: ['./employee-insurance-crud.component.scss']
})
export class EmployeeInsuranceCrudComponent implements OnInit {
  @Output() empInsuranceIdEmitter: EventEmitter<number> = new EventEmitter<number>();
  @Input() empInsurance: EmployeeInsurance;
  @Input() context: Context;
  @Input() empInsurances: EmployeeInsurance[] = [];
  @Input() selectedEmployeeId: any;
  @Input() employeeName: any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  public empInsuranceForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;
  public insurances: Insurance[] = [];
  public insuranceId: number;
  public banks: Bank[] = [];
  public empInsurancePlans: InsurancePlan[] = [];
  public empInsuranceId: number;
  public nomineeForm: FormGroup;
  public submittedInsurance: boolean = false;
  public types: string;
  public families: Family[] = [];
  private imageUrl: string;
  public image: string;
  public selectedInsuranceId: number;
  public startDate: FormGroup;

  constructor(
    private settingsService: SettingsService,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private commonService: CommonService,
    private employeeService: EmployeeService,
    private datePipe: DatePipe,
    private companyService: CompanyService,
    private domainService: DomainService,
  ) { }

  ngOnInit(): void {
    this.setEmpInsurance(this.empInsurance);
    this.setNomineeForm([]);
    if (this.empInsurance?.id) {
      this.getNominees(); 
    }

    this.settingsService.getInsurances(false).subscribe((insurances: Insurance[]) => {
      this.insurances = insurances.filter(insurance => insurance.id);
      if (this.insurances.length > 0) {
        this.selectedInsuranceId = this.insurances[0].id; 
    }
    if(this.selectedInsuranceId){
      this.fetchInsurancePlans(this.selectedInsuranceId); 
    }
    });   
    if (this.context?.persona === 'CLIENT') {
      this.employeeService.getBanks(this.selectedEmployeeId).subscribe((banks) => {
        this.banks = banks.filter((bank) => !bank.disabled);
      });   
    } else {
      this.employeeService.getBanks(this.context.employeeId).subscribe((banks) => {
        this.banks = banks.filter((bank) => !bank.disabled);
      });
    }
    if (this.context?.persona === 'CLIENT') {
      this.companyService.getFamiles(this.selectedEmployeeId,true).subscribe((families) => (this.families = families));
      
    } else {
      this.companyService.getFamiles(this.context.employeeId,true).subscribe((families) => (this.families = families));
    }
  }

  public fetchInsurancePlans(insuranceId: number) {
    this.settingsService.getInsurancePlans(insuranceId).subscribe((insurancePlans) => {
      this.empInsurancePlans = insurancePlans.filter(plan => plan.active === true);
    });
    
  }

  public setEmpInsurance(empInsurance?: EmployeeInsurance) {
    if (!empInsurance)
      empInsurance = {
        id: null,
        startDate: null,
        endDate: null,
        policy: null,
        lastNotified: null,
        message: null,
        nextNotification: null,
        status: 'SEND',
        notes: null,
        active: true,
        disabled: false,
        insuranceId: null,
        planId: null,
        planName: null,
        employeeId: null,
        employeeName: null,
        bankId: null,
        bankName: null,
      } as EmployeeInsurance;
    this.empInsuranceForm = this.fb.group({
      id: this.fb.control(empInsurance?.id || null),
      startDate: this.fb.control(this.datePipe.transform(empInsurance.startDate ? empInsurance.startDate : '', 'yyyy-MM-dd'), [Validators.required]),
      endDate: this.fb.control(this.datePipe.transform(empInsurance.endDate ? empInsurance.endDate : '', 'yyyy-MM-dd'), [Validators.required]),
      policy: this.fb.control(empInsurance.policy, [Validators.required]),
      lastNotified: this.fb.control(this.datePipe.transform(empInsurance.lastNotified ? empInsurance.lastNotified : '', 'yyyy-MM-dd'), []),
      message: this.fb.control(empInsurance.message, [Validators.required]),
      nextNotification: this.fb.control(this.datePipe.transform(empInsurance.nextNotification ? empInsurance.nextNotification : '', 'yyyy-MM-dd'), [Validators.required]),
      status: this.fb.control(empInsurance.status, []),
      notes: this.fb.control(empInsurance.notes, []),
      active: this.fb.control(empInsurance.active, []),
      insuranceId: this.fb.control(empInsurance.insuranceId, [Validators.required]),
      planId: this.fb.control(empInsurance.planId, [Validators.required]),
      planName: this.fb.control(empInsurance.planName, []),
      employeeId: this.fb.control(empInsurance.employeeId || this.context.persona=='HR'? this.context.employeeId :this.selectedEmployeeId),
      employeeName: this.fb.control(empInsurance.employeeName, []),
      bankId: this.fb.control(empInsurance.bankId, [Validators.required]),
      bankName: this.fb.control(empInsurance.bankName, []),
      disabled: this.fb.control(empInsurance.disabled, []),
    });
    this.empInsuranceForm.valueChanges.subscribe(value => this.modified = true);
  }

  get i() {
    return this.empInsuranceForm.controls;
  }

  private getEmpInsurance(id: number) {
    this.settingsService.getEmpInsurance(id).subscribe(empInsurance => {
      if (empInsurance.id) {
        this.setEmpInsurance(empInsurance);
        this.empInsurance=empInsurance;
      }
    });
  }

  public saveEmpInsurance(inProgress?: any) {
    this.submitted = true;
    if (this.empInsuranceForm.valid) {
      const empInsurance: EmployeeInsurance = this.empInsuranceForm.value;
      if (!this.modified) {
        this.commonService.setToastr(200, `Coverage ${empInsurance.policy} has been updated successfully!`);
        return;
      }
      
      inProgress.value = true;
      if (empInsurance.id) {
        this.settingsService.updateEmpInsurance(empInsurance.id, {
          ...empInsurance, 
          employeeId: this.selectedEmployeeId 
        }).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.passEntry.emit(response);
              const empInsuranceId = parseInt(response.payload);
              this.empInsuranceForm.get('id').setValue(empInsuranceId);
              this.getEmpInsurance(empInsuranceId);
              inProgress.value = false;
              this.commonService.setToastr(200, `Coverage ${empInsurance.policy} has been updated successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } else {
        this.settingsService.createEmpInsurance(empInsurance).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.passEntry.emit(response);
              this.commonService.setToastr(200, `Coverage ${empInsurance.policy} has been created successfully!`);
              const empInsuranceId = parseInt(response.payload);
              this.empInsuranceForm.get('id').setValue(empInsuranceId);
              this.getEmpInsurance(empInsuranceId);
              this.empInsuranceId = empInsuranceId;
              this.empInsuranceIdEmitter.emit(empInsuranceId);

              inProgress.value = false;
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      }
    }
  }

  public async getAndSetBase64(event: any) {
    const image: string = await this.commonService.convertImgToBase64(event);
    if (!image) return;
    this.imageUrl = image;
  }


  private saveImage(sid: number, refType: string, label: string, url: string) {
    let image: Image = {
      id: null,
      sid: sid,
      type: refType,
      label: label,
      image: url,
    };
    image.image = url
    this.domainService.createImage(image).subscribe({
      next: (response: string) => {
      },
      error: (error: HttpErrorResponse) => {
      }
    });
  }

  private getImage() {
    this.domainService.getImage('EMPLOYEE', 'EMPLOYEE', this.empInsurance.id, 'relationshipProof').subscribe(image => {
     //  this.image = image;
     this.image=image.payload;
    });
  }


  public getNominees() {
    this.settingsService.getNominees(this.empInsuranceForm?.value?.id).subscribe((nominees: Nominee[]) => {
      if (this.empInsuranceForm?.value?.id) {
        this.setNomineeForm(nominees);
      }
    });
  }

  public get nominees(): FormArray {
    return this.nomineeForm.get('nominees') as FormArray;
  }

  public addNominee(nominee?: Nominee) {
    this.nominees.push(this.createNominee(nominee));
  }

  private setNomineeForm(nominees: Nominee[]) {
    this.nomineeForm = this.fb.group({
      nominees: this.fb.array([]),
    });

    if (!nominees || nominees.length === 0) {
      this.addNominee();
    }
    nominees.forEach(nominee => this.addNominee(nominee));
  }

  private createNominee(nominee?: Nominee): FormGroup {
    return this.fb.group({
      id: this.fb.control(nominee?.id || null, []),
      name: this.fb.control(nominee?.name, [Validators.required]),
      percentage: this.fb.control(nominee?.percentage, [Validators.required,Validators.pattern(RegExp.number)]),
      address: this.fb.control(nominee?.address, [Validators.required]),
      pan: this.fb.control(nominee?.pan, [Validators.required,Validators.pattern(RegExp.pan)]),
      relationshipProof: this.fb.control(nominee?.relationshipProof, []),
      legalCompliance: this.fb.control(nominee?.legalCompliance, [Validators.required]),
      notes: this.fb.control(nominee?.notes, [Validators.required]),
      prime: this.fb.control(nominee?.prime || false, []),
      disabled: this.fb.control(nominee?.disabled || false, []),
      employeeInsuranceId: this.fb.control(nominee?.employeeInsuranceId || this.empInsuranceForm?.value?.id, []),
      familyId: this.fb.control(nominee?.familyId, [Validators.required]),
      familyName: this.fb.control(nominee?.familyName, []),
    });
  }

  public deleteNominee(index: number, nominee: FormGroup): void {
    const nomineeId = nominee.value?.id;
    if (nomineeId) {
      this.settingsService.deleteNominee(nomineeId).subscribe({
        next: (message: any) => {
          if (message.text) {
            if(this.nominees.length>1){
              this.nominees.removeAt(index);
            } else{
              this.nominees.at(index).reset();
            }
            this.commonService.setToastr(200, message.text);
          } else {
            this.commonService.setToastr(500, 'Something went wrong! Please try again.');
          }
        },
        error: (error: HttpErrorResponse) => {
          this.commonService.setToastr(error.status, error?.error?.response || error.message);
        },
      });
    } else {
      this.nominees.removeAt(index);
      if (this.nominees.length < 1) {
        this.addNominee();
      }
    }
  }

  public saveNominee(inProgress: any) {
    this.submitted = true;
    this.nomineeForm.markAllAsTouched();
  
    if (this.nomineeForm.invalid) {
      this.toastr.error('Please fill all required fields correctly.');
      return;
    }
  
    const employeeInsuranceId = this.empInsuranceForm.value.id;
    const plans = this.nominees.value.map((nominee: Nominee) => ({
      ...nominee,
      employeeInsuranceId: employeeInsuranceId,
    }));
  
    const nomineesToUpdate = plans.filter((nominee: Nominee) => nominee.id);
    const nomineesToCreate = plans.filter((nominee: Nominee) => !nominee.id);
  
    inProgress.value = true;
  
    if (nomineesToUpdate.length > 0) {
      this.updateNominees(nomineesToUpdate, inProgress);
    }
    const isUpdateProcess = nomineesToUpdate.length > 0;
    if (nomineesToCreate.length > 0) {
      this.createNominees(nomineesToCreate, inProgress,isUpdateProcess);
    }
  
    if (nomineesToUpdate.length === 0 && nomineesToCreate.length === 0) {
      inProgress.value = false;
    }
  }
  
  private updateNominees(nominees: Nominee[], inProgress: any) {
    this.settingsService.updateNominee(nominees).subscribe({
      next: (response: Message) => {
        this.getNominees();
        this.saveImage(this.empInsurance.id, 'INSURER', 'relationshipProof', this.imageUrl);
        this.commonService.setToastr(200, response.text);
        inProgress.value = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error?.response || error.message, 'Error');
        inProgress.value = false;
      },
    });
  }
  private createNominees(nominees: Nominee[], inProgress: any,isUpdateProcess: boolean = false) {    
    this.settingsService.createNominee(nominees).subscribe({
      next: (message: Message) => {
        if (!isUpdateProcess && !message.failed) {
          this.getNominees();
          this.saveImage(this.empInsurance?.id, 'INSURER', 'relationshipProof', this.imageUrl);
          this.commonService.setToastr(200, message.text);
          inProgress.value = false;
        } else if (message.failed) {
          this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
          inProgress.value = false;
        }
      },
    });
  }
  
}
